module.exports = __webpack_public_path__ + "static/hack-f0dfa1658eae9c9063ddd91191c66b96.jpg";